import React, { Component } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Info from "@material-ui/icons/Info";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import Delete from "@material-ui/icons/Delete";
import ModeEdit from "@material-ui/icons/Edit";
import AddBox from "@material-ui/icons/AddBox";
import Visibility from "@material-ui/icons/Visibility";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { grey, darkBlack, lightBlack } from "@material-ui/core/colors";
import Tooltip from "@material-ui/core/Tooltip";
import Collapse from "@material-ui/core/Collapse";
import Typography from "@material-ui/core/Typography";
import { clone, isEqual } from "lodash";
import PoiEditDialog from "./PoiEdit";
import ScrollContainer from "./tables/ScrollContainer";

const grey400 = grey["400"];

class InfoIcon extends Component {
  render() {
    return (
      <IconButton
        touch={true}
        tooltip={this.props.tooltip}
        tooltipPosition="bottom-left"
        tooltipStyles={{ width: "100px" }}
      >
        <Info color={grey400} />
      </IconButton>
    );
  }
}

class PointOfIntrestItem extends Component {
  //TODO: Why the event is not stopped?
  onRemoveClick(event) {
    event.stopPropagation();
    event.preventDefault();
    this.props.onRemoveClick(event);
  }
  constructor(props) {
    super(props);
    this.state = {
      openEdit: false,
      expand: false
    };
  }

  handleOpen() {
    this.setState({ openEdit: true });
  }

  handleClose() {
    this.setState({ openEdit: false });
  }

  handleSubmit(data) {
    if (data.changed) {
      this.props.onEdit(data);
    }
    this.setState({ openEdit: false });
  }

  onEditClick() {
    this.handleOpen();
  }

  toggleClick(e) {
    e.stopPropagation();
    this.setState({ expand: !this.state.expand });
  }

  render() {
    const smallButton = {
      width: 32,
      height: 32,
      padding: 0,
      margin: 0
    };
    const headerStyle = {
      display: "flex",
      lineHeight: "32px",
      borderBottom: "1px solid lightgray",
      marginBottom: "2px"
    };
    let subtextStyle = null;
    let button_var = null;

    if (this.state.expand) {
      subtextStyle = {
        fontSize: "smaller",
        color: "gray",
        lineHeight: "1.1em",
        textOverflow: "ellipsis",
        overflow: "hidden"
      };
      //button_var = <ExpandLess color='gray'/>
      button_var = <ExpandLess />;
    } else {
      subtextStyle = {
        fontSize: "smaller",
        color: "gray",
        maxHeight: "3.3em",
        lineHeight: "1.1em",
        textOverflow: "ellipsis",
        overflow: "hidden"
      };
      button_var = <ExpandMore />;
    }
    const spacer = <span style={{ margin: "auto" }} />;
    let buttons;
    if (this.props.editable) {
      buttons = [
        <Tooltip key={1} title={"Switch to view"}>
          <IconButton
            //tooltip="Switch to view"
            style={smallButton}
            onClick={this.props.onClick.bind(this)}
            key={0}
          >
            <Visibility />
          </IconButton>
        </Tooltip>,
        <Tooltip key={2} title={"Remove this view"}>
          <IconButton
            //tooltip="Remove this view"
            style={smallButton}
            onClick={this.onRemoveClick.bind(this)}
            key={1}
          >
            <Delete />
          </IconButton>
        </Tooltip>,
        <Tooltip key={3} title={"Edit description"}>
          <IconButton
            //tooltip="Edit description"
            style={smallButton}
            onClick={this.props.onEdit}
            key={2}
          >
            <ModeEdit />
          </IconButton>
        </Tooltip>
        // <PoiEditDialog
        //   open={this.state.openEdit}
        //   onCancel={this.handleClose.bind(this)}
        //   onSubmit={this.handleSubmit.bind(this)}
        //   description={this.props.description}
        //   title={this.props.title}
        //   key={4}
        // />
      ];
    } else {
      buttons = [];
    }

    buttons.push(
      <IconButton
        key={5}
        style={smallButton}
        onClick={this.toggleClick.bind(this)}
      >
        {button_var}
      </IconButton>
    );

    const itemStyle = {
      paddingTop: "4px",
      paddingBottom: "4px"
    };

    if (this.props.editable) {
      itemStyle.paddingLeft = "0px";
    }

    return (
      <ListItem
        onClick={this.props.editable ? null : this.props.onClick}
        button={!this.props.editable}
        dense
        style={itemStyle}
        selected={this.props.selected}
        //innerDivStyle={{paddingTop: '4px', paddingBottom: '4px'}}
      >
        {this.props.editable && (
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignContent: "space-between"
            }}
          >
            {this.props.position != -1 && (
              <Tooltip key={1} title={"Move view up the list"}>
                <IconButton
                  size="small"
                  onClick={this.props.onReorder.bind(null, -1)}
                  key={1}
                >
                  <ArrowDropUp fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {this.props.position != 1 && (
              <Tooltip key={2} title={"Move view down the list"}>
              <IconButton
                size="small"
                onClick={this.props.onReorder.bind(null, 1)}
                key={2}
              >
                <ArrowDropDown fontSize="small" />
              </IconButton>
              </Tooltip>
            )}
          </div>
        )}
        <div style={{ width: "100%" }}>
          <div style={headerStyle}>
            {this.props.title}
            {spacer}
            {buttons}
          </div>
          <div>
            <p style={subtextStyle}> {this.props.description} </p>
          </div>
        </div>
      </ListItem>
    );
  }
}

class IconListSubheader extends Component {
  render() {
    const headerStyle = {
      display: "flex"
    };
    const iconStyle = {
      marginLeft: "auto"
    };
    return (
      <ListSubheader style={headerStyle}>
        {this.props.text}
        {this.props.editable && (
          <IconButton
            style={iconStyle}
            tooltip={this.props.tooltip}
            onClick={this.props.onClick}
          >
            {this.props.icon}
          </IconButton>
        )}
      </ListSubheader>
    );
  }
}

const concat = (x, y) => x.concat(y);

class PointsOfIntrest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pois_open: {}
    };
  }

  pois_collapse(id) {
    const pois_open = clone(this.state.pois_open);
    pois_open[id] = !pois_open[id];
    this.setState({ pois_open: pois_open });
  }

  componentWillMount() {
    let pois_open = {};
    this.props.elements.forEach(el => {
      if (el.hasOwnProperty("pois")) {
        pois_open[el.project_id] = false;
      }
    });
    this.setState({ pois_open: pois_open });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevProps.elements, this.props.elements)) {
      const pois_open = clone(this.state.pois_open);
      this.props.elements.forEach(el => {
        if (
          el.hasOwnProperty("pois") &&
          !pois_open.hasOwnProperty(el.project_id)
        ) {
          pois_open[el.project_id] = false;
        }
      });
      this.setState({ pois_open: pois_open });
    }
  }

  generate_elements_list(elements, editable) {
    return elements
      .map((elem, index) => {
        if (elem.hasOwnProperty("pois")) {
          if (!this.state.pois_open.hasOwnProperty(elem.project_id)) {
            const pois_open = clone(this.state.pois_open);
            pois_open[elem.project_id] = false;
            this.setState({ pois_open: pois_open });
          }
          return [
            <ListItem
              key={index}
              button
              onClick={this.pois_collapse.bind(this, elem.project_id)}
            >
              <ListItemText primary={elem.title} />
              {this.state.pois_open[elem.project_id] ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItem>,
            <Collapse
              key={"c" + index}
              in={this.state.pois_open[elem.project_id]}
              transitionDuration="auto"
              unmountOnExit
            >
              {this.generate_elements_list(elem.pois, false)}
            </Collapse>
          ];
        }
        return [
          <PointOfIntrestItem
            key={index}
            position={index == 0 ? -1 : index == elements.length - 1 ? 1 : 0}
            title={elem.title}
            description={elem.description}
            onClick={this.props.onClick.bind(null, elem)}
            editable={editable}
            selected={elem.selected}
            onRemoveClick={this.props.onRemove.bind(this, elem.id)}
            onEdit={this.props.onEdit.bind(null, elem.id)}
            onReorder={this.props.onReorder.bind(null, elem.id)}
          />
        ];
      })
      .reduce(concat, []);
  }

  render() {
    const infoIcon = <InfoIcon />;
    const elements = this.generate_elements_list(
      this.props.elements,
      this.props.editable
    );
    elements.push(
      <PointOfIntrestItem
        key={-1}
        title="Overview"
        description="Reset the view to show whole scene"
        onClick={this.props.onClick.bind(this, null)}
        editable={false}
      />
    );

    return (
      <Typography
        component="div"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        {this.props.editable && (
          <Button
            style={{ margin: "5px" }}
            label="Add current view"
            color="primary"
            variant="contained"
            onClick={() => this.props.onEdit(null)}
          >
            Add current view
          </Button>
        )}
        <ScrollContainer inner={List}>{elements}</ScrollContainer>
      </Typography>
    );
  }
}

export default PointsOfIntrest;
